module.exports = __webpack_public_path__ + "static/media/5.a68f0977.jpg";